<template>
  <!-- 根元素绑定设备类名：根据判断结果添加 "pc" 或 "mobile" 类 -->
  <div id="app" :class="deviceClass">
    <router-view/>
  </div>
</template>

<script>
// 1. 导入设备判断函数（需根据你的实际文件路径调整！）
import { isMobile, isPC } from "@/common/utils/device"; // 假设函数在 @/utils/device.js 中

export default {
  name: 'App',
  data() {
    return {
      deviceClass: '' // 存储设备类名："pc" 或 "mobile"
    };
  },
  mounted() {
    // 2. 页面挂载时判断设备类型，设置类名（仅执行一次，设备类型不会动态变化）
    this.deviceClass = isMobile() ? 'mobile' : 'pc';
  }
};
</script>

<style>
/* 3. 基础通用样式（所有设备共用） */
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  box-sizing: border-box; /* 统一盒模型，避免padding影响宽高 */
}

* {
  box-sizing: inherit; /* 子元素继承盒模型 */
}

p,
ul {
  padding: 0;
  margin: 0;
}

ul li {
  list-style-type: none;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  width: 100%;
}

/* 4. PC端专属样式（仅当 #app 有 "pc" 类时生效） */
#app.pc html {
  overflow: auto;
  font-size: 80px; /* PC端基础字体大小 */
  /* PC端大屏适配（保留原逻辑） */
  @media (min-width: 1440px) {
    font-size: 90px;
  }
  @media (min-width: 1600px) {
    font-size: 100px;
  }
  @media (min-width: 1921px) {
    font-size: 110px;
  }
  @media (min-width: 2560px) {
    font-size: 120px;
  }
}

#app.pc body {
  overflow: hidden; /* PC端固定布局，禁止滚动 */
  min-width: 1440px; /* PC端最小宽度约束 */
  min-height: 710px; /* PC端最小高度约束 */
  position: relative;
  font-size: 16px; /* PC端默认字体大小（基于html的80px计算，16px=0.2rem） */
}

/* 5. 移动端专属样式（仅当 #app 有 "mobile" 类时生效） */
#app.mobile html {
  overflow-x: hidden; /* 禁止移动端横向滚动（避免内容溢出） */
  font-size: 16px; /* 移动端基础字体大小（1rem=16px，方便计算） */
}

#app.mobile body {
  overflow: auto; /* 移动端允许纵向滚动（内容超出时可滑动） */
  min-width: auto; /* 移除PC端最小宽度约束（适配手机屏幕） */
  min-height: auto; /* 移除PC端最小高度约束 */
  font-size: 14px; /* 移动端默认字体大小（更适配小屏幕） */
  position: relative;
}

/* 6. 移动端横竖屏补充适配（可选，优化横屏体验） */
#app.mobile body[orient="landscape"] {
  font-size: 13px; /* 横屏时缩小字体，避免内容拥挤 */
}
</style>


// WEBPACK FOOTER //
// src/App.vue